import { useState } from "react";

export function TokenAvatar(props: {
  name: string;
  symbol: string;
  image?: string;
  size?: "small" | "large";
}) {
  const { name, symbol, image, size = "small" } = props;
  const [failed, setFailed] = useState(false);
  const initials = (symbol || name).slice(0, 2).toUpperCase();
  return (
    <span className={`token-avatar token-avatar--${size}`} aria-hidden="true">
      {image && !failed ? (
        <img src={image} alt="" loading="lazy" onError={() => setFailed(true)} />
      ) : (
        <span>{initials}</span>
      )}
    </span>
  );
}
